<app-component-header [tabs]="['Sample Reception Cell']"></app-component-header>
<p-blockUI [blocked]="blocked">
    <div id="center">
        <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
</p-blockUI>

<div #mainDiv name="main-component-div" class="m-4">
    <div name="top-row" class="mx-1 mb-1 grid grid-nogutter">
        <div class="lg:col-6 md:col-6 sm:col-12 flex flex-column justify-content-start">
            <div class="p-inputgroup">
                <span class="m-1 text-primary text-lg">Run-ID:</span>
                <span class="m-1 text-primary text-lg">{{selectedRun?.runId}}</span>
                <button *ngIf="showCommentbutton()" (click)="showRunComment=true"
                    class="text-primary bg-transparent border-transparent rounded-md focus:outline-none text-4xl">
                    <i class="far fa-comment-dots"></i>
                </button>
            </div>
            <div>
                <button class="m-1 p-button text-sm w-max h-1rem p-button-outlined"
                    (click)="showRunTableSidebarVisible()">Select Run</button>
                <button class="m-1 p-button text-sm w-max h-1rem p-button-outlined"
                    (click)="removeRunSelection()">Remove Selection</button>
            </div>
        </div>
        <div class="lg:col-3 md:col-3 sm:col-12 flex flex-column justify-content-start">
            <div class="p-inputgroup">
                <span class="m-1 text-primary text-sm">Status: </span>
                <span class="m-1 text-primary text-sm">{{selectedRun?.status}}</span>
            </div>
            <div class="p-inputgroup">
                <span class="m-1 text-primary text-sm">Project ID: </span>
                <span class="m-1 text-primary text-sm">{{selectedRun?.projectName}}</span>
            </div>
            <div class="p-inputgroup">
                <span class="m-1 text-primary text-sm">Workflow: </span>
                <span class="m-1 text-primary text-sm">{{selectedRun?.workFlow}}</span>
            </div>
        </div>
    </div>

    <div class="w-12 mt-5 lg:flex justify-content-start gap-6">
        <div class="lg:w-3 md:w-12 sm:w-12 m-1">
            <div class="lg:w-12 md:w-10 sm:w-10">
                <p-panel styleClass="single-sample-panel" class="text-base panel-height" header="New Run">
                    <div class="py-8 m-3">
                        <div class="w-11">
                            <button pButton class="w-12 start-button h-2rem md:text-sm text-white px-0"
                                label="New Run" (click)="removeRunSelection()"></button>
                        </div>
                        <div class="my-3 w-12" *ngIf="selectedRun.runId">
                            <button pButton class="w-4 action-button h-2rem md:text-sm text-primary px-0 "
                                label="Run-ID"></button>
                            <input class="h-2rem w-7 pl-3 inline-flex" id="input" placeholder="Run ID"
                                [value]="selectedRun.runId" [disabled]="disableRunFormFields()" readonly />
                        </div>
                        <div class="my-3 w-12">
                            <button pButton class="w-4 action-button h-2rem md:text-sm text-primary px-0 "
                                label="Project-ID"></button>
                            <p-dropdown class="h-2rem w-7 inline-flex" placeholder="Select Project ID" [filter]="true"
                                filterBy="label" name="projectList" [(ngModel)]="selectedProject"
                                [options]="projectsList" optionLabel="label" optionValue="value"
                                (onChange)="getWorkflowsForProject()" [disabled]="disableRunFormFields()"></p-dropdown>
                        </div>
                        <div class="my-3 w-12">
                            <button pButton class="w-4 action-button h-2rem md:text-sm text-primary px-0 "
                                label="Workflow"></button>
                            <p-dropdown class="h-2rem w-7 inline-flex" placeholder="Select Workflow"
                                [options]="workflowList" optionLabel="label" optionValue="value"
                                name="workflowList" [(ngModel)]="selectedWorkflow" [disabled]="disableRunFormFields()"></p-dropdown>
                        </div>
                        <div class="my-3 w-12">
                            <button pButton class="w-4 action-button h-2rem md:text-sm text-primary px-0 "
                                label="Line"></button>
                            <p-dropdown class="h-2rem w-7 inline-flex" placeholder="Select Line" [filter]="true"
                                filterBy="label" name="lineList" optionLabel="label" optionValue="value"
                                [options]="linesList" [(ngModel)]="selectedRun.line" [disabled]="disableRunFormFields()"></p-dropdown>

                        </div>
                        <div class="my-3 w-12">
                            <div class="ui-inputgroup boxIdField" id="inputClass">
                                <button pButton class="w-4 action-button h-2rem md:text-sm text-primary px-0"
                                    label="Box-ID"></button>
                                <input class="h-2rem w-7 pl-3 inline-flex" (keydown.enter)="searchForBox()"
                                    [(ngModel)]="boxIDSearchValue" placeholder="Box ID">
                            </div>
                            <span *ngFor="let box of selectedRun.boxes; let index = index">
                                <div class="my-2 flex align-items-center">
                                    <input pInputText [value]="box" style="width: 54%; margin-left: 35%; height: 35px;"
                                        readonly />
                                    <button *ngIf="selectedRun.runId === '' || selectedRun.boxes.length > 1" pButton
                                        icon="fa fa-times-circle" class="h-2rem complete-button text-white w-1"
                                        (click)="deleteValue(index)"></button>
                                </div>
                            </span>
                        </div>

                        <div class="w-11">
                            <div class="text-center py-1" *ngIf="isValidProcessStep()">
                                {{getProcessStepStartTimestamp() | date: 'dd.MM.yy HH:mm'}} | {{ getProcessStepStartPuid() }}
                            </div>
                            <button pButton class="w-12 complete-button h-2rem md:text-sm text-white px-0"
                                label="Start Run" (click)="startRun()" [disabled]="disableRunFormFields()"></button>
                        </div>
                    </div>
                </p-panel>
            </div>
        </div>
        <div class="lg:w-3 md:w-12 sm:w-12 m-1"
            *ngIf="selectedRun.runId && selectedRun.samples.length !==0">
            <div class="lg:w-12 md:w-10 sm:w-10">
                <p-panel styleClass="single-sample-panel" class="text-base panel-height" header="Sample Request">
                    <div class="m-3 w-11">
                        <div class="mb-2">
                            Samples : {{ (selectedRun.samples) ? selectedRun.samples.length : 0}}<br/>
                            <span *ngIf="showNoScanDMSamples()">
                                Barcode not scannable: {{selectedRun.noScanDM}} {{selectedRun.sampleType}}
                            </span>
                        </div>
                        <p-table [value]="selectedRun?.samples" [scrollable]="true" scrollHeight="50vh" class="mt-2">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="border-right-none" scope="col">Sample Barcode</th>
                                    <th class="border-left-none" scope="col">Status</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-sample let-i="rowIndex">
                                <tr [ngClass]="{'td-no-color': i % 2 === 0, 'td-color': i % 2 !== 0}">
                                    <td class="border-right-none">
                                        {{sample?.sampleId}}
                                    </td>
                                    <td class="border-left-none">
                                        {{sample?.status}}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-panel>
            </div>
        </div>
        <div class="lg:w-3 md:w-12 sm:w-12 m-1"
            *ngIf="selectedRun.runId && selectedRun.plates.length !== 0">
            <div class="lg:w-12 md:w-10 sm:w-10">
                <p-panel styleClass="single-sample-panel" class="text-base panel-height" header="Plate Feedback">
                    <div class="m-3 w-11">
                        <p-table [value]="selectedRun?.plates" [scrollable]="true" scrollHeight="50vh">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th scope="col">Plate Created</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-plate let-i="rowIndex">
                                <tr [ngClass]="[ i % 2 === 0 ? 'td-no-color' : 'td-color',classForDuplicatePlate(plate)]"
                                    (click)="clickPlateID(plate)" (keydown)="clickPlateID(plate)">
                                    <td>
                                        {{plate}}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-panel>
            </div>
        </div>
    </div>
</div>

<p-dialog header="Update New PlateID!!" [(visible)]="showDuplicatePlateIdDialog" [modal]="true" position="top"
    [style]="{width: '27vw'}" (onHide)="clearPopUpFields()">
    <div>
        <div class="w-12 flex">
            <button pButton class="w-6 h-2rem text-white" type="button" label="Duplicate ID"></button>
            <input class="w-6 h-2rem" name="duplicatePlate" [(ngModel)]="duplicatePlateID" size="5" />
        </div>
        <div class="w-12 flex mt-3">
            <button pButton class="w-6 h-2rem" type="button" label="New Plate ID"></button>
            <input name="newPlateID" class="w-6 h-2rem" [(ngModel)]="newPlateID" size="5"
                (input)="disableUpdateButtonOnChange()" (keyup.enter)="checkNewPlateIDPresent()" />
        </div>
    </div>

    <div class="col-12 flex justify-content-center mt-2">
        <button pButton class="h-2rem start-button" label="Update New PlateID" id="add-comment"
            (click)="updateNewPlateIDInPlate()" [disabled]="disableUpdatePlateIDButton"></button>
    </div>
</p-dialog>

<p-dialog header="{{ getCommentsDialogHeader() }}" class="bg-primary button-dialog" [(visible)]="showRunComment"
    [maximizable]="true" [modal]="true" [style]="{ 'width': '50vw', 'height': '65vh' }"
    [breakpoints]="{'960px':'75vw','648px':'85vw'}">
    <app-comment *ngIf="selectedRun !== null" [selectedLabID]="selectedLabId" [runStatus]="selectedRun.status"
        [puid]="puid" [displayDialog]="showRunComment" [runId]="selectedRun.runId" [showRunComment]="true"
        (onCommentClosed)="showRunComment = false">
    </app-comment>
</p-dialog>

<p-sidebar [(visible)]="plateTableSidebarVisible" [appendTo]="mainDiv" position="left" [blockScroll]="true"
    styleClass="w-3">
    <app-plate-list [plateTableVisible]="plateTableSidebarVisible" [availableRunStatuses]="availableRunStatuses"
        [showDateFilter]="true" [selectedPlate]="selectedRun" (fetchRunEmitter)="fetchRun($event)"
        (removeSelectionEmitter)="removeRunSelection()">
    </app-plate-list>
</p-sidebar>